import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 3d-mot — FTUE demo (3 essais progressifs).
 *
 * Pedagogique uniquement, pas de scoring :
 *   E1 : 3 cibles statiques (focus sur l'identification).
 *   E2 : 4 cibles, vitesse lente.
 *   E3 : 4 cibles, vitesse normale (proche staircase reel).
 */
import { useState } from 'react';
const DEMO_STEPS = [
    {
        idx: 1,
        title: 'Essai 1 : repere les cibles',
        hint: 'Trois spheres rouges. Memorise leur position.',
    },
    {
        idx: 2,
        title: 'Essai 2 : suivi lent',
        hint: 'Quatre cibles cette fois. Garde le regard centre.',
    },
    {
        idx: 3,
        title: 'Essai 3 : vitesse normale',
        hint: 'Tu connais la routine. La vitesse va s ajuster a toi.',
    },
];
export function Demo({ onComplete, onSkip }) {
    const [stepIdx, setStepIdx] = useState(0);
    const step = DEMO_STEPS[stepIdx];
    const isLast = stepIdx === DEMO_STEPS.length - 1;
    const handleNext = () => {
        if (isLast)
            onComplete();
        else
            setStepIdx((i) => i + 1);
    };
    return (_jsxs("div", { className: "flex flex-1 flex-col items-center gap-s4 py-s4 text-center", children: [_jsx("p", { className: "font-mono text-[9.5px] uppercase tracking-[0.30em] text-cyan-text-faint", children: "Demo guidee" }), _jsx("h2", { className: "font-display text-[22px] font-medium leading-7 tracking-cy-display text-cyan-text", children: step.title }), _jsx("p", { className: "max-w-[320px] text-[13.5px] text-cyan-text-secondary", children: step.hint }), _jsx("div", { className: "flex h-[240px] w-full items-center justify-center border border-cyan-border-faint bg-cyan-surface", children: _jsxs("span", { className: "text-cyan-text-secondary", children: ["[demo etape ", step.idx, "/3]"] }) }), _jsxs("div", { className: "flex flex-col items-stretch gap-s3 self-stretch", children: [_jsx("button", { type: "button", onClick: handleNext, className: "inline-flex h-12 w-full items-center justify-center bg-cyan-core font-display text-[14px] font-medium tracking-[-0.01em] text-cyan-surface transition active:scale-[0.985] hover:bg-cyan-network", children: isLast ? 'Demarrer la session' : 'Essai suivant' }), _jsx("button", { type: "button", onClick: onSkip, className: "text-[12px] text-cyan-text-secondary underline-offset-4 hover:underline", children: "Passer la demo" })] })] }));
}
//# sourceMappingURL=demo.js.map